import { MemberUnitListItem } from "./MemberUnitListItem";
import { MemberSummary } from "@ses-mams/api-contract";
import { OrgUnitApprovers } from "./OrgUnitApprovers";
import { Box } from "~/components/ui/box";
import { Text } from "~/components/ui/text";
import { Stack } from "~/components/ui/stack";

type Unit = {
  id: string;
  name: string;
  approvers?: MemberSummary[];
};

type Cluster = {
  id: string;
  name: string;
  approvers?: MemberSummary[];
  units: Unit[];
};

type Zone = {
  id: string;
  name: string;
  approvers?: MemberSummary[];
  clusters: Cluster[];
};

type Props = {
  hierarchy?: {
    zones: Zone[];
    standaloneUnits: Unit[];
  };
  size?: "small" | "xsmall" | "standard" | "large" | "xlarge";
};
export const OrgHierarchyList = ({ hierarchy, size = "large" }: Props) => {
  return (
    <>
      {hierarchy?.standaloneUnits.map(unit => (
        <MemberUnitListItem
          size={size}
          key={unit.id}
          id={unit.id}
          name={unit.name}
          approvers={unit.approvers || []}
        />
      ))}
      {hierarchy?.zones
        ? hierarchy?.zones.map(zone => (
            <Stack key={zone.id} marginTop="xsmall" gap="xsmall">
              <Text size={size} weight="medium">
                {zone.name}
              </Text>
              {zone.approvers ? (
                <OrgUnitApprovers approvers={zone.approvers} />
              ) : null}
              {zone.clusters.map(cluster => (
                <Box key={cluster.id} marginLeft="large" marginTop="small">
                  <Text size={size} weight="medium">
                    {cluster.name}
                  </Text>
                  {cluster.approvers ? (
                    <OrgUnitApprovers approvers={cluster.approvers} />
                  ) : null}
                  {cluster.units.map(unit => (
                    <Box key={unit.id} marginLeft="large" marginTop="small">
                      <MemberUnitListItem
                        size={size}
                        id={unit.id}
                        name={unit.name}
                        approvers={unit.approvers || []}
                      />
                    </Box>
                  ))}
                </Box>
              ))}
            </Stack>
          ))
        : null}
    </>
  );
};
